<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    @change="editSingleSettingHandler"
    :hasButtons="false"
  >
    <template #sms_api_provider_name.input.inner="{ value }">
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="text-body-2" :class="{ 'text--disabled': !isModuleEnabled }">
            {{ value }}
          </span>
        </v-col>
      </v-row>
    </template>
    <template #postForm>
      <v-row no-gutters class="align-baseline">
        <v-col cols="2">
          <data-input v-bind="phoneNumberParams" v-model="phoneNumber" :disabled="!isModuleEnabled"> </data-input>
        </v-col>
        <v-col cols="8" class="pl-10">
          <v-row no-gutters class="justify-start">
            <template v-if="!isSmsSent">
              <v-col cols="auto">
                <base-button
                  :disabled="!isValidPhoneNumber || !isModuleEnabled"
                  @click="sendSmsHandler"
                  translation-path="admin.sendTestSms"
                  :loading="loading"
                ></base-button>
              </v-col>
            </template>
            <template v-else>
              <v-col>
                <v-row no-gutters>
                  <v-col cols="auto">
                    <v-icon color="success">
                      mdi-check
                    </v-icon>
                  </v-col>
                  <v-col cols="auto" class="success--text">
                    {{ $i18n.t('admin.smsSent') }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="auto" class="pl-5">
                    <link-underlined @click="sendSmsHandler" translation-path="admin.sendAgain"> </link-underlined>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';
import LinkUnderlined from '@/components/LinkUnderlined';

export default {
  name: 'SmsSettings',
  components: {
    AdminWrapper,
    DataInput,
    LinkUnderlined,
  },
  data: () => ({
    isSmsSent: false,
    loading: false,
    phoneNumber: null,
    phoneNumberParams: {
      dataType: {
        name: 'text',
      },
      hint: 'admin.phoneNumberHint',
    },
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules.SMS.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@sms_module_enabled'),
    isValidPhoneNumber() {
      return /(?:(?:(?:\+|00)?48)|(?:\(\+?48\)))?(?:1[2-8]|2[2-69]|3[2-49]|4[1-8]|5[0-9]|6[0-35-9]|[7-8][1-9]|9[145])\d{7}/.test(
        this.phoneNumber
      );
    },
    inputs() {
      return [
        {
          name: 'sms_module_enabled',
          canBeDisabled: false,
          hasSuffix: false,
          straightText: this.additionalModuleName,
          dataType: {
            name: 'switch',
          },
          subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
        },
        {
          name: 'sms_api_provider_name',
          translationPath: 'admin.smsGatewayName',
        },
      ];
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (!nV) {
        this.isSmsSent = false;
      }
    },
  },
  methods: {
    editSingleSetting: call('admin/editSingleSetting'),
    sendSms: call('sms/sendTestSms'),
    editSingleSettingHandler(value, name) {
      if (name === 'sms_module_enabled') {
        this.editSingleSetting({
          key: name,
          body: {
            value,
          },
        });
      } else {
        return;
      }
    },
    async sendSmsHandler() {
      try {
        this.loading = true;
        await this.sendSms({
          phone_number: this.phoneNumber,
        });
        setTimeout(() => {
          this.loading = false;
          this.isSmsSent = true;
        }, 500);
        if (this.isSmsSent) {
          this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
            message: this.$i18n.t('success.sendSms'),
          });
        }
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
